import React from "react";
import "../UIcss/Aboutus.css";
import { FaRocket, FaCode, FaUserCircle, FaGraduationCap, FaLayerGroup, FaTerminal } from "react-icons/fa";

const Aboutus = () => {
  return (
    <div className="about-container">
      {/* Decorative Background Elements */}
      <div className="bg-glow-1"></div>
      <div className="bg-glow-2"></div>

      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-badge">The Future of Learning</div>
        <h1>CodePulse-R<span>.com</span></h1>
        <div className="hero-main-message">
          <p>
            Empowering the next generation of developers with a futuristic 
            UI framework and an advanced interactive learning ecosystem.
          </p>
        </div>
      </section>

      {/* Brand Vision Section */}
      {/* <section className="brand-vision">
        <div className="vision-content">
          <div className="vision-line"></div>
          <div className="vision-text-block">
            <h2>Our Core Vision</h2>
            <p>
              At <strong>CodePulse-R.com</strong>, we believe that technical education 
              should be as visually stunning as it is logically profound. We are not 
              just building a UI library; we are crafting a <strong>futuristic gateway</strong> 
              for developers to master complex technologies like Java, SQL, and React 
              in an environment that inspires innovation.
            </p>
          </div>
          <div className="vision-line"></div>
        </div>
      </section> */}

      {/* Stats Section */}
      <section className="about-stats">
        <div className="stat-item">
          <span className="stat-number">50+</span>
          <span className="stat-label">UI Components</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">100+</span>
          <span className="stat-label">Coding Tasks</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">99%</span>
          <span className="stat-label">Performance</span>
        </div>
      </section>

      {/* Core Pillars */}
      <section className="about-mission">
        <div className="mission-card">
          <div className="card-icon-wrapper">
            <FaLayerGroup className="mission-icon" />
          </div>
          <h2>Premium UI Library</h2>
          <p>
            A high-performance component library built with vanilla CSS for maximum 
            flexibility, zero dependencies, and stunning futuristic aesthetics.
          </p>
        </div>
        <div className="mission-card">
          <div className="card-icon-wrapper">
            <FaGraduationCap className="mission-icon" />
          </div>
          <h2>Interactive Education</h2>
          <p>
            Our sophisticated exam system provides real-time code evaluation 
            and interactive learning paths for Java, SQL, and Modern Web Tech.
          </p>
        </div>
        <div className="mission-card">
          <div className="card-icon-wrapper">
            <FaTerminal className="mission-icon" />
          </div>
          <h2>Live Code Engine</h2>
          <p>
            An integrated execution environment that allows students to write, 
            debug, and run code directly in the browser with instant feedback.
          </p>
        </div>
      </section>

      {/* The Core Team Section */}
      <section className="about-visionary">
        <div className="section-label">The Core Team</div>
        <div className="visionaries-grid">
          {/* Ratan's Profile */}
          <div className="visionary-card">
            <div className="visionary-image-wrapper">
              <div className="visionary-image-placeholder">
                <FaUserCircle />
              </div>
              <div className="image-accent"></div>
            </div>
            <div className="visionary-text">
              <h2>Ratan</h2>
              <p className="visionary-role">Owner & Lead Full Stack Trainer</p>
              <p className="visionary-bio">
                A sharp-minded visionary with 18+ years of experience in the IT industry. 
                Ratan has trained thousands of developers and is the driving force 
                behind the CodePulse-R ecosystem.
              </p>
              <div className="visionary-tags">
                <span>18+ Yrs Exp</span>
                <span>Full Stack Expert</span>
              </div>
            </div>
          </div>

          {/* Ravindra's Profile */}
          <div className="visionary-card">
            <div className="visionary-image-wrapper">
              <div className="visionary-image-placeholder">
                <FaUserCircle />
              </div>
              <div className="image-accent cyan"></div>
            </div>
            <div className="visionary-text">
              <h2>Ravindra</h2>
              <p className="visionary-role">Logical Strategist & Architect</p>
              <p className="visionary-bio">
                The logical powerhouse of the team. Ravindra's exceptional analytical 
                thinking ensures that every component in CodePulse-R is 
                architected with absolute logical precision.
              </p>
              <div className="visionary-tags">
                <span>Logical Thinking</span>
                <span>System Architect</span>
              </div>
            </div>
          </div>

          {/* Harika's Profile */}
          <div className="visionary-card">
            <div className="visionary-image-wrapper">
              <div className="visionary-image-placeholder">
                <FaUserCircle />
              </div>
              <div className="image-accent"></div>
            </div>
            <div className="visionary-text">
              <h2>Harika</h2>
              <p className="visionary-role">Core Developer</p>
              <p className="visionary-bio">
                Specializing in building seamless and interactive user experiences. 
                Harika brings complex UI requirements to life with elegant and 
                performant frontend solutions.
              </p>
              <div className="visionary-tags">
                <span>UI Specialist</span>
                <span>React Developer</span>
              </div>
            </div>
          </div>

          {/* Lalitha's Profile */}
          <div className="visionary-card">
            <div className="visionary-image-wrapper">
              <div className="visionary-image-placeholder">
                <FaUserCircle />
              </div>
              <div className="image-accent cyan"></div>
            </div>
            <div className="visionary-text">
              <h2>Lalitha</h2>
              <p className="visionary-role">Core Developer</p>
              <p className="visionary-bio">
                Focused on the robustness and scalability of the component library. 
                Lalitha ensures that our codebase remains modular, clean, and 
                easy for other developers to integrate.
              </p>
              <div className="visionary-tags">
                <span>Frontend Architect</span>
                <span>System Design</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom Sections Grid */}
      <div className="about-bottom-grid">
        {/* Partnership & Portfolio Section */}
        <section className="about-partnership">
          <div className="partnership-card">
            <div className="section-label">Strategic Partnership</div>
            <h2>CodePulse-R & Sathyatech</h2>
            <p>
              We are proud to be the official design and technology partner for 
              <strong> sathyatech.com</strong>. The entire Sathyatech digital 
              ecosystem was designed by the CodePulse-R team.
            </p>
            <div className="partnership-footer">
              <a href="https://sathyatech.com" target="_blank" rel="noopener noreferrer" className="partnership-link">
                Visit sathyatech.com
              </a>
            </div>
          </div>
        </section>

        {/* Story Section */}
        <section className="about-story">
          <div className="story-card">
            <div className="story-header">
              <FaRocket className="story-icon" />
              <h2>The Journey</h2>
            </div>
            <p>
              What started as a tool to standardize complex technical assessments 
              evolved into <strong>CodePulse-R</strong>. We've created a unique 
              space where developers can grow.
            </p>
            <div className="story-footer">
              <a href="https://codepulse-r.com" target="_blank" rel="noopener noreferrer" className="story-link">
                Explore codepulse-r.com
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Aboutus;
